import { initials } from '../../lib/orbs'
import { cn } from '../../lib/utils'

// The one client badge: a company is an ink square with mist initials (a person
// is a mist circle, see Avatar), or an uploaded logo once ENG-132 lands.
const TEXT = { sm: 'text-label', md: 'text-caption', lg: 'text-body' } as const

export default function OrgBadge({
  name,
  size = 24,
  radius = 'rounded-md',
  logoUrl,
  className,
}: {
  name: string
  size?: number
  radius?: string
  logoUrl?: string | null
  className?: string
}) {
  const scale = size >= 40 ? 'lg' : size >= 28 ? 'md' : 'sm'
  return (
    <span
      style={{ width: size, height: size }}
      className={cn('flex shrink-0 items-center justify-center overflow-hidden', radius, !logoUrl && 'bg-foreground', className)}
    >
      {logoUrl ? (
        <img src={logoUrl} alt="" className="size-full object-cover" />
      ) : (
        <span className={cn('font-semibold text-mist', TEXT[scale])}>{initials(name)}</span>
      )}
    </span>
  )
}
